import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { Twitter, Instagram, Linkedin, Youtube, Apple } from "lucide-react";

const PLAY_STORE = "https://play.google.com/store/apps/details?id=app.emergent.neetpgprep7c9f4774b";

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="bg-white rounded-2xl p-3 inline-block">
            <Logo />
          </div>
          <p className="mt-4 text-sm text-slate-400 leading-relaxed max-w-xs">
            India&apos;s most trusted AI-Powered platform for NEET PG preparation. Made with care for future doctors.
          </p>

          <div className="mt-5 flex items-center gap-2">
            <a href={PLAY_STORE} target="_blank" rel="noopener noreferrer" data-testid="footer-play-store" className="inline-flex items-center gap-2 bg-white text-slate-900 px-4 h-11 rounded-xl text-sm font-semibold hover:bg-slate-100">
              <svg viewBox="0 0 24 24" className="h-5 w-5"><path fill="#34D399" d="M4 2.5v19l9.5-9.5z"/><path fill="#FBBF24" d="M13.5 12L4 21.5 17 14z"/><path fill="#F87171" d="M17 14l-3.5-2L4 2.5z"/><path fill="#60A5FA" d="M17 14l4-2.3c1.3-.75 1.3-2.65 0-3.4L17 10l-3.5 2z"/></svg>
              Google Play
            </a>
            <div className="inline-flex items-center gap-2 bg-slate-800 text-slate-300 px-4 h-11 rounded-xl text-sm font-semibold opacity-80 cursor-not-allowed">
              <Apple className="h-5 w-5" />
              App Store · Soon
            </div>
          </div>
        </div>

        <div className="md:col-span-2">
          <div className="text-white font-semibold mb-3">Product</div>
          <ul className="space-y-2 text-sm">
            <li><a href="#features" className="hover:text-white">Features</a></li>
            <li><a href="#courses" className="hover:text-white">Courses</a></li>
            <li><a href="#test-series" className="hover:text-white">Test Series</a></li>
            <li><a href="#pricing" className="hover:text-white">Pricing</a></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="text-white font-semibold mb-3">Account</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/login" className="hover:text-white">Login</Link></li>
            <li><Link to="/register" className="hover:text-white">Register</Link></li>
            <li><Link to="/forgot-password" className="hover:text-white">Forgot Password</Link></li>
            <li><Link to="/dashboard" className="hover:text-white">Dashboard</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-white font-semibold mb-3">Stay in the loop</div>
          <p className="text-sm text-slate-400 mb-3">Tips, free MCQs and product updates — every week.</p>
          <form className="flex gap-2" onSubmit={(e) => e.preventDefault()}>
            <input
              type="email"
              placeholder="you@example.com"
              data-testid="footer-newsletter-input"
              className="flex-1 h-11 px-3 rounded-xl bg-slate-800 border border-slate-700 text-white placeholder:text-slate-500 focus:outline-none focus:border-blue-500"
            />
            <button type="submit" data-testid="footer-newsletter-submit" className="h-11 px-4 rounded-xl bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold">
              Subscribe
            </button>
          </form>
          <div className="mt-5 flex items-center gap-3">
            {[
              { i: Twitter, l: "twitter" },
              { i: Instagram, l: "instagram" },
              { i: Linkedin, l: "linkedin" },
              { i: Youtube, l: "youtube" },
            ].map((s) => {
              const I = s.i;
              return (
                <a key={s.l} href="#" aria-label={s.l} className="h-9 w-9 rounded-full bg-slate-800 hover:bg-blue-600 flex items-center justify-center transition-colors">
                  <I className="h-4 w-4" />
                </a>
              );
            })}
          </div>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-slate-500">
          <span>© {new Date().getFullYear()} DearDr · deardr.co.in</span>
          <span>Secure payments via Razorpay · Coming soon</span>
        </div>
      </div>
    </footer>
  );
}
